import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import MainLayout from '../components/layout/MainLayout';
import { webAppConfig } from '../config/appConfig';

export default function PrivacyPage() {
  return (
    <MainLayout
      className="landing-shell"
      header={(
        <Header
          className="landing-header"
          brandHref={webAppConfig.routes.home}
          logoSrc={webAppConfig.brand.logoPath}
          brandText={webAppConfig.brand.name}
          brandClassName="landing-brand"
          logoClassName="landing-brand-logo"
          brandTextClassName="landing-brand-name"
          variant="landing"
        />
      )}
      footer={(
        <Footer className="landing-footer" variant="landing" />
      )}
    >
      <main className="landing-section legal-page" aria-labelledby="privacy-title">
        <div className="legal-hero">
          <span className="legal-kicker">Legal</span>
          <h1 id="privacy-title">Privacy Policy</h1>
          <p><strong>Effective date:</strong> April 22, 2026</p>
          <p>
            {webAppConfig.brand.name} is a simple platform that connects job seekers with companies for on-demand
            work. We keep things minimal and transparent when it comes to your data.
          </p>
        </div>

        <div className="legal-card">
          <h2>What we collect</h2>
          <p>
            We only collect what&rsquo;s needed to create and use your account:
          </p>
          <ul className="legal-list">
            <li>Email and password (securely stored)</li>
            <li>Basic account details</li>
          </ul>
          <p>
            You may choose to share additional information such as:
          </p>
          <ul className="legal-list">
            <li>Skills, profile details (for job seekers)</li>
            <li>Company name and job details (for companies)</li>
          </ul>
          <p>
            Providing extra information is completely optional and only helps improve matching.
          </p>

          <h2>How we use your data</h2>
          <p>
            We use your information only to:
          </p>
          <ul className="legal-list">
            <li>Let you log in and access your account</li>
            <li>Connect job seekers with companies</li>
            <li>Enable basic platform features (like posting jobs or applying)</li>
          </ul>
          <p>
            We do <strong>not</strong> use your data for anything unrelated to the platform.
          </p>

          <h2>Data sharing</h2>
          <ul className="legal-list">
            <li>Your profile or job-related information is only shared with other users as needed to make the platform work</li>
            <li>We do <strong>not</strong> sell your data</li>
          </ul>

          <h2>Cookies &amp; basic usage</h2>
          <p>
            We may use simple cookies or storage to:
          </p>
          <ul className="legal-list">
            <li>Keep you logged in</li>
            <li>Maintain basic functionality</li>
          </ul>

          <h2>Your control</h2>
          <p>
            You are in control of your data:
          </p>
          <ul className="legal-list">
            <li>Add more info if you want better visibility</li>
            <li>Keep it minimal if you prefer privacy</li>
            <li>You can request account deletion anytime</li>
          </ul>

          <h2>Security</h2>
          <p>
            We take reasonable steps to protect your login and data, but no system is 100% secure.
          </p>

          <h2>Updates</h2>
          <p>
            We may update this policy as the platform grows. Any updates will be reflected here.
          </p>

          <p>
            <strong>In short:</strong><br />
            We only collect what&rsquo;s needed for login and platform use. Anything extra is your choice and for your
            benefit.
          </p>
        </div>
      </main>
    </MainLayout>
  );
}
